const splitTextToArray = (text) => {
  return text.replace(/"/g, '')
  .split(/\r\n|\n|\r|- /)
  .filter(item => item.length > 0)
  .filter(item => item !== 'nan')
  .map(item => ({ name: item }))
}

export default splitTextToArray